/**
 * Returns FRONT_CONFIG
 * @returns {import('../../../../config/frontConfig').FrontConfig}
 */
function getFrontConfig() {
  const { FRONT_CONFIG = false } = window;
  if (!FRONT_CONFIG) {
    throw new Error('FRONT_CONFIG unavailable');
  }
  return FRONT_CONFIG;
}

export default getFrontConfig;
